export const DISPERSEABI = {
    iotexTestnet: "0x3744c2e13e51A9305D2E9381f5E5D0BBd1a733a4",
    MoonbeamTestnet: "0x6E283A176062e74A5c742Fd9d0B4C274e5984EAd",
    hpbMainnet: "0x4FF748A9BbC1a69ABB28084A222E53265f535B8a",
};
